import React ,{useState,useEffect}from 'react';
import axios from 'axios';
import { makeStyles} from '@material-ui/core/styles';
// import Typography from '@material-ui/core/Typography';
import Sidebar from '../component/Sidebar';
import Bread from '../component/Breadcrumbs';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
// import MultiSelect from '../component/MultiSelect';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import {AdminDetail as CountryList} from '../Services/AdminLogin';
import {AuthData} from '../Services/Authdata';
import useForm from './Auth/useForm';
import {DestinationValidation} from './Auth/UpdateValidation';
// import {store} from '../Services/Destination';
import ImageUploader from 'react-images-upload';
import { useHistory } from "react-router-dom";

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

function Alerts(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}




const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  imagePreview:{
    marginTop:'10px',
    marginBottom:"10px"
  },
}));


export default function Trip(props) {
  const br = [{
    'title':'Trip',
    'icon':"",
    'url':'/trip'
  },{
    'title':'Add Trip',
    'icon':"",
    'url':'/trip/create'
  }];
  let history = useHistory()
  const classes = useStyles();
  const [file, setFile] = React.useState(null)
  const [loader, setLoader] = useState("");
  const [action, setAction] = useState(false)
  const [country, setCountry] = useState([1]);
  const [clist, setClist] = useState([]);
  const [thumb, setThumb] = useState(null);
  const [pictures,setPictures] = useState([])
  //Using For Snackbar
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [message, setMessage] = React.useState("");
  const [state, setState] = React.useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal, open } = state;

  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
  
    setState({ ...state, open: false });
  };
  //End
  useEffect(()=>{
    CountryList('countrylist','GET',AuthData().token).then((result)=>{
      const db = result.data.map((name) => (
        <MenuItem key={name.id} value={name.id}>{name.name_en}</MenuItem>
    ))
    setClist(db);
    })
    
  },[])
  const initialValues = {
		name: "",
    nickname: "",
    about:"",
    image:"",
    thumbnail:'',
    country:""
  }
  const { values, errors, handleChange, handleSubmit } = useForm(initialValues,profile,DestinationValidation);
  function profile(){
    
    var fd = new FormData();
    fd.append('name',values.name);
    fd.append('nickname',values.nickname);
    fd.append('about',values.about);
    fd.append('country',values.country);
    fd.append('thumbnail',thumb,thumb.name);
    fd.append('image',file,file.name);
    setLoader(<CircularProgress color="secondary" style={{"position":"absolute",marginLeft:"40%",marginTop:'10%',zIndex:"+99999999"}}/>)
    setAction(true)
    setTimeout(()=>{
      axios.post(process.env.REACT_APP_BASEAPI_URL+'destination/store',fd,{
        headers:{
          Authorization:'Bearer '+AuthData().token,
          //'Content-Type':'multipart/form-data'
        }
      }).then(res =>{
      if(res.data.status===1){
        setMessage("Congratulation!!! your Trip has been created successfully");
        setState({ ...state, open: true });
        setTimeout(() =>{
          history.push('/trip')
        },1000)
       
        // history.push({
        //   pathname: '/trip',
        //   state: { message: "Congratulation!!! your Trip has been created successfully" }
        // })
      }else{
        setAction(false)
      }
      });
    },1000)
  }
  const fileHandler = (e) =>{
    setFile(e.target.files[0]);
    console.log(e.target.type);
    handleChange(e);
  }
  const thumbHandler = (e) =>{
    setThumb(e.target.files[0]);
    handleChange(e);
  }

  const onDrop = (picture) => {
    const e = {target:{
      type:"file",
      name:'image',
      files:picture
    }};
    handleChange(e);
    //console.log(picture[0]);
    setFile(picture[0]);
    //setPictures([...pictures, picture]);
    // console.log(pictures)
    setPictures(picture);
   // console.log(thumb.name);
      
  }
  const onDropThumb = (picture) => {
    const e = {target:{
      type:"file",
      name:'thumbnail',
      files:picture
    }};
    handleChange(e);
    setThumb(picture[0]);
   //console.log(thumb)
  } 

  // const mySubmit = (e) =>{
  //   e.preventDefault();
  //   var fd = new FormData();
  //   fd.append('name',"Anuj");
  //   fd.append('image',file,file.name);
  //   console.log(fd.values);
  //   axios.post('http://localhost:8000/api/destination/store',fd,{
  //     headers:{
  //       Authorization:'Bearer '+AuthData().token,
  //       //'Content-Type':'multipart/form-data'
  //     }
  //   }).then(res =>{
  //   console.log(res);
  //   });
  // }
  
  
  return (
    <div className={classes.root}>
      <Snackbar open={open} anchorOrigin={{ vertical, horizontal }} key={vertical + horizontal} autoHideDuration={6000} onClose={handleCloseSnack}>
        <Alerts onClose={handleCloseSnack} severity="success">
         {message}
        </Alerts>
      </Snackbar>
      <Sidebar />
      <main className={classes.content}>
      <div className={classes.toolbar} />
      <Bread data={br} />
       <h1> Destinations</h1>
       
       <div>
       {/* <CircularProgress color="secondary" style={{"position":"absolute",marginLeft:"40%",marginTop:'10%',zIndex:"+99999999"}}/> */}
       {loader}
        <form noValidate onSubmit={handleSubmit}>
          <Grid container spacing={3}>
               <Grid item xs={12} md={6} lg={6}>
                <FormControl 
                style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                  <TextField
                  error={errors.name?true:false}
                  helperText={errors.name}
                  id="name"
                  label="Name"
                  variant="outlined"
                  type="text"
                  name='name' 
                  size="small"
                  required
                  color="secondary"
                  onChange={handleChange}
                  />
                </FormControl>   
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <FormControl 
                style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                  <TextField 
                  error={errors.nickname?true:false}
                  helperText={errors.nickname}
                  id="nickname"
                  label="Nickname"
                  variant="outlined"
                  type="text"
                  name='nickname' 
                  required
                  size="small"
                  color="secondary"
                  onChange={handleChange}
                  />
                </FormControl>   
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <FormControl 
                style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                  <TextField 
                  error={errors.about?true:false}
                  helperText={errors.about}
                  multiline
                  rowsMax={4}
                  id="nickname"
                  label="About"
                  variant="outlined"
                  type="text"
                  name='about' 
                  required
                  size="small"
                  color="secondary"
                  onChange={handleChange}
                  />
                </FormControl>   
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
              <FormControl variant="outlined" style={{width:'100%'}}>
                <InputLabel id="demo-simple-select-outlined-label">Country</InputLabel>
                <Select
                error={errors.country?true:false}
                helperText={errors.country}
                  labelId="demo-simple-select-outlined-label"
                  id="country"
                  label="country"
                  name='country'
                  defaultValue={country}
                  onChange={handleChange}
                >
                  {clist}
                </Select>
            </FormControl>   
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <FormControl 
                  style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                    <ImageUploader
                      withIcon={false}
                      name="image"
                      //defaultImages={[process.env.REACT_APP_AWS_URL+props.location.state.name.image.replace(/[\[\]']+/g,'').replace(/['"]+/g, '')]}
                      withPreview={true}
                      withLabel={false}
                      buttonText='Upload images'
                      onChange={onDrop}
                      imgExtension={['.jpg', '.gif', '.png', '.gif']}
                      maxFileSize={5242880}
                      singleImage={true}
                  />
                </FormControl>
                <span style={{color:"red"}}>{errors.image}</span>
              </Grid>
              {/* <Grid item xs={12} md={6} lg={6}>
              <FormControl 
                style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
              <TextField 
                  error={errors.image?true:false}
                  helperText={errors.image}
                  id="image"
                  variant="outlined"
                  type="file"
                  name='image' 
                  required
                  color="secondary"
                  onChange={(e)=>{fileHandler(e)}}
                  mode='multiple'
                  />
                  </FormControl>
                  <div className={classes.imagePreview}>
                    {file===null
                    ?""
                    :<span 
                    onClick={(e) => {setFile(null);}}
                    style={{position:"absolute",marginTop:"-1%",padding:'5px',background:"red",borderRadius:"50%",marginLeft:'8%',cursor:'pointer'}}>
                      x
                      </span>}
                    <img alt={file?file.name:""} src={file? URL.createObjectURL(file) : null} style={{width:"20%"}}/>
                  </div>
              </Grid> */}

              <Grid item xs={12} md={6} lg={6}>
                  <FormControl style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                  <ImageUploader
                    withIcon={false}
                    name="thumbnail"
                    withLabel={false}
                    //defaultImages={[process.env.REACT_APP_AWS_URL+props.location.state.name.image.replace(/[\[\]']+/g,'').replace(/['"]+/g, '')]}
                    withPreview={true}
                    buttonText='Upload Thumbnails'
                    onChange={onDropThumb}
                    imgExtension={['.jpg', '.gif', '.png', '.gif']}
                    maxFileSize={5242880}
                    singleImage={true}  
                  />
                  </FormControl>
                  <span style={{color:"red"}}>{errors.thumbnail}</span>
              </Grid>  

              {/* <Grid item xs={12} md={6} lg={6}>
              <FormControl 
                style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
              <TextField 
                  error={errors.thumbnail?true:false}
                  helperText={errors.thumbnail}
                  id="thumbnail"
                  variant="outlined"
                  type="file"
                  name='thumbnail' 
                  required
                  color="secondary"
                  // ref={fileInput}
                  onChange={ (e) => thumbHandler(e)}

                  />
                  </FormControl>
                  <div className={classes.imagePreview}>
                    {thumb===null
                    ?""
                    :<span 
                    onClick={(e) => {setThumb(null);}}
                    style={{position:"absolute",marginTop:"-1%",padding:'5px',background:"red",borderRadius:"50%",marginLeft:'8%',cursor:'pointer'}}>
                      x
                      </span>}
                    <img alt={thumb?thumb.name:""} src={thumb? URL.createObjectURL(thumb) : null} style={{width:"20%"}}/>
                  </div>

              </Grid> */}
              
          </Grid>

          <FormControl style={{marginBottom:"5px"}}>
          <Button disabled={action} type="submit" variant="contained" color="primary" disableElevation>
          Save
          </Button>
          </FormControl>
        </form>
        
       </div>
      </main>
    </div>
    
   
  );
}


// WEBPACK FOOTER //
// ./src/Pages/Destination.js